import React, { PropTypes } from "react";
import styles from "components/manage-categories/add-category-modal.scss";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";

export const AddCategoryModal = ({
  accountId,
  isAddCategoryVisible,
  newCategory,
  onCreateCategory,
  onHideAddCategory,
  onUpdateNewCategoryName
}) => (
  <Modal
    isVisible={ isAddCategoryVisible }
    onClose={ onHideAddCategory }
    transitionName="add-category"
  >
    <h2>Add new category</h2>
    <div className={ styles["field-cell"] }>
      <div>Category Name</div>
      <input
        className={ styles.fields }
        defaultValue={ newCategory }
        onChange={ (e) => onUpdateNewCategoryName(e.target.value) }
      />
    </div>
    <div className={ styles["button-container"] }>
      <Button link onClick={ onHideAddCategory }>cancel</Button>
      <Button
        onClick={ () => { onHideAddCategory(); onCreateCategory(accountId, newCategory); } }
        primary
      >
        Add Category
      </Button>
    </div>
  </Modal>
);

AddCategoryModal.defaultProps = {
  newCategory: null
};

AddCategoryModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  isAddCategoryVisible: PropTypes.bool.isRequired,
  newCategory: PropTypes.string,
  onCreateCategory: PropTypes.func.isRequired,
  onHideAddCategory: PropTypes.func.isRequired,
  onUpdateNewCategoryName: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/manage-categories/add-category-modal.jsx